module.exports = __webpack_public_path__ + "media/upcoming.95527ead.mp4";